import angular from 'angular';

class FormController {
    constructor(TipKabine) {
        this.TipKabine = TipKabine;
        this.fields = this.getFields();
        this.model = this.model || {};
        this.clone = angular.copy(this.model);
        this.onSubmit = this.onSubmit || angular.noop;
        this.onCancel = this.onCancel || angular.noop;
    }

    submit() {
        this.TipKabine.create(this.clone, {upsert: true}).then((data) => {
            this.onSubmit({model: data});
        });
    }

    cancel() {
        this.onCancel();
    }

    getFields(){
        return {
            naziv: {
                key: 'naziv',
                type: 'hInput',
                templateOptions: {
                    label: 'Naziv'
                }
            }
        };
    }
}

FormController.$inject = ['TipKabine'];

export default FormController;



// WEBPACK FOOTER //
// ./app/components/tip/form/form.controller.js